import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import '../style/updateTab.css';
import '../style/overviewTab.css';
import OverviewTabFormFile from "./ApplicationPolicy/overviewTabFormFile";
import { COMMENT_AREA_INFO_MESSAGE, SOLICITOR_USERS } from '../helpers/variables';
import { FormGroup, Popover, Button, Loader, Link, HorizontalRule, Alert } from 'arag-ui-lib';
import { FORM_GROUP_VARIANTS, SECONDARY_VARIANT_STYLE } from '../helpers/formGroupVariants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import OverviewTabFilterList from './overviewTabFilterList';
import { PRIMARY, RIGHT, DOTS, ERROR, SUCCESS, LARGE, MEDIUM } from '../helpers/constants';

const OverviewTab = (props) => {

    const {
        overviewTab,
        CalculateFeaturedOverview,
        handleSubmit,
        HandleInputChange,
        OnDrop,
        changeOverviewAttachment,
        removeOverviewAttachment,
        addAnotherOverviewAttachment,
        CheckUserOverviewTabCheckBox,
        ApplicationPolicyStore,
        UserRole,
    } = props;

    const [isClicked, setIsClicked] = useState(false);
    const commentRefs = useRef({});
    const parse = require('html-react-parser');
    const infoMessageText = parse(COMMENT_AREA_INFO_MESSAGE)
    let overviewData = CalculateFeaturedOverview()[0];

    return (
        <div className="col-sm-12 updateTab-Wrapper">
            <form
                className="form-horizontal"
                onSubmit={(evt) => {
                    evt.preventDefault();
                    handleSubmit(evt);
                }}
            >
                <FormGroup
                    labelSize={'col-sm-3'}
                    inputSize={'col-sm-6'}
                    label={CONTENT_STRINGS.ADD_COMMENT}
                    variant={FORM_GROUP_VARIANTS.TEXT_AREA}
                    inputProps={{
                        key: 'comment',
                        name: 'comments',
                        value: overviewTab.comments || '',
                        onChange: (evt) => { HandleInputChange(evt.target.name, evt.target.value) }
                    }}
                    infoText={infoMessageText}
                    requiredStyle={SECONDARY_VARIANT_STYLE}
                    formGroupTestId={'overview-new-comment-entry-field'}
                    tooltipTestId={'overview-comment-help-text'}
                />
                {
                    overviewTab.attachments.map((attachment, index) => {
                        return (
                            <OverviewTabFormFile
                                onAttachmentDrop={OnDrop}
                                changeOverviewAttachment={changeOverviewAttachment}
                                attachmentIndex={index}
                                removeOverviewAttachment={removeOverviewAttachment}
                                key={index}
                                attachment={attachment}
                            />
                        );
                    })
                }
                <div className="form-group">
                    <div className='col-sm-3'></div>
                    <div className="col-sm-6 ">
                        <Link
                            variant={'tertiary'}
                            label={CONTENT_STRINGS.ADD_ATTACHMENT}
                            arrowDirection={'left'}
                            onClick={addAnotherOverviewAttachment}
                            linkTestId={'overview-add-attachment'}
                        />
                    </div>
                    <div className="col-sm-3"></div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-9'}>
                        <span>{overviewTab.tagsDescription}</span>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-sm-9'}>
                        <span>{parse(overviewTab.sizeLimitDescription)}</span>
                    </div>
                </div>
                {
                    !SOLICITOR_USERS.includes(UserRole) ?
                        <div className='row col-sm-12'>
                            <FormGroup
                                labelSize={'col-sm-3 custom-label'}
                                inputSize={'col-sm-1'}
                                label={'All'}
                                variant={FORM_GROUP_VARIANTS.CHECKBOX}
                                inputProps={{
                                    name: 'all',
                                    id: 'all',
                                    checked: ApplicationPolicyStore.usersOverviewTabCheckBoxes.all,
                                    onChange: (evt) => { setIsClicked(!isClicked) }
                                }}
                                requiredStyle={SECONDARY_VARIANT_STYLE}
                                hasInlineElements={true}
                                formGroupTestId={'overview-new-comment-visible-all'}
                                inlineGroupElements={
                                    isClicked ?
                                        <div className='col-sm-5' style={{ marginTop: '40px' }}>
                                            <Popover
                                                popover={{
                                                    title: CONTENT_STRINGS.ARE_YOU_SURE,
                                                    content:
                                                        <Button
                                                            variant={PRIMARY}
                                                            type={"button"}
                                                            label={CONTENT_STRINGS.YES}
                                                            onClick={() => {
                                                                CheckUserOverviewTabCheckBox('all');
                                                                setIsClicked(!isClicked);
                                                            }}
                                                            buttonTestId={'overview-new-comment-visible-all-popover-yes'}
                                                        />,
                                                    closeLabel: CONTENT_STRINGS.NO,
                                                }}
                                                onPopoverLeave={() => { setIsClicked(!isClicked) }}
                                                popoverId={'overview-new-comment-visible-all-popover'}
                                                buttonTestId={'overview-new-comment-visible-all-popover-no'}
                                            />
                                        </div>
                                    :   null
                                }
                            />
                            <FormGroup
                                labelSize={'col-sm-3 custom-label'}
                                inputSize={'col-sm-6'}
                                label={CONTENT_STRINGS.ARAG}
                                variant={FORM_GROUP_VARIANTS.CHECKBOX}
                                inputProps={{
                                    name: 'arag',
                                    id: 'arag',
                                    checked: ApplicationPolicyStore.usersOverviewTabCheckBoxes.arag,
                                    onChange: (evt) => { CheckUserOverviewTabCheckBox('arag') }
                                }}
                                formGroupTestId={'overview-new-comment-visible-arag'}
                                requiredStyle={SECONDARY_VARIANT_STYLE}
                            />
                            <FormGroup
                                labelSize={'col-sm-3 custom-label'}
                                inputSize={'col-sm-6'}
                                label={CONTENT_STRINGS.ARAG_AND_MEDICAL_EXPERTS}
                                variant={FORM_GROUP_VARIANTS.CHECKBOX}
                                inputProps={{
                                    name: 'aragAndMedicalExperts',
                                    id: 'aragAndMedicalExperts',
                                    checked: ApplicationPolicyStore.usersOverviewTabCheckBoxes.aragAndMedicalExperts,
                                    onChange: (evt) => { CheckUserOverviewTabCheckBox('aragAndMedicalExperts') }
                                }}
                                formGroupTestId={'overview-new-comment-visible-arag-me'}
                                requiredStyle={SECONDARY_VARIANT_STYLE}
                            />
                        </div>
                        :
                        null
                }
                <div className="form-group">
                    <div className='row'>
                        <div className="col-sm-3"> </div>
                        <div className="col-sm-3">
                            <Button
                                type={'submit'}
                                variant={PRIMARY}
                                label={CONTENT_STRINGS.SUBMIT}
                                arrowDirection={RIGHT}
                                buttonTestId={'overview-new-comment-submit'}
                            />
                        </div>
                        <div className="col-sm-3">
                            { overviewTab.posting ? <Loader variant={DOTS} dotSize={LARGE}/> : null }
                        </div>
                    </div>
                </div>
                {
                    (overviewTab.badMsg !== '') ?
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-sm-3'></div>
                                <div className='col-sm-6'>
                                    <Alert
                                        variant={ERROR}
                                        label={overviewTab.badMsg}
                                    />
                                </div>
                            </div>
                        </div>
                    :   null
                }
                {
                    (overviewTab.msg !== '') ?
                        <div className="form-group">
                            <div className='row'>
                                <div className='col-sm-3'></div>
                                <div className='col-sm-6'>
                                    <Alert
                                        variant={SUCCESS}
                                        label={overviewTab.msg}
                                    />
                                </div>
                            </div>
                        </div>
                    :   null
                }
            </form>
            <div className="row">
                <div className="col-sm-12">
                    <HorizontalRule variant='dotted' className="applicationPolicy-hr" />
                </div>
            </div>
            {
                overviewTab.fetching
                    ? <div className="col-sm-12"> <Loader variant={DOTS} dotSize={MEDIUM}/> </div>
                    : <OverviewTabFilterList
                        overviewData={overviewData}
                        UserRole={UserRole}
                        commentRefs={commentRefs}
                        pagerProps={{
                            pageSize: parseInt(overviewTab.selectedView),
                            totalItems: overviewTab.totalRecords,
                            totalPages: overviewTab.totalBoxes,
                            page: overviewTab.page || 1,
                            goAtPrevious: props.goAtPrevious,
                            goAtNext: props.goAtNext,
                            goAtStart: props.goAtStart,
                            goAtEnd: props.goAtEnd,
                            goAtPage: props.goAtPage,
                            pagerTestId: 'overview-comments-pager'
                        }}
                        filterOptions={props.overviewVisibilityOptions}
                        includeNoChanges={props.overviewTab.includeNoChanges}
                        filterValue={props.overviewTab.overviewfilterBy.name}
                        onFilterChange={props.onDropdownChange}
                        onCheckboxChange={props.onCheckboxChange}
                        onFilterApply={props.overviewTabFilterVisibility}
                        onFilterReset={props.overviewTabFilterVisibilityReset}
                    />
            }
        </div>
    );
};

OverviewTab.propTypes = {
    overviewTab: PropTypes.shape({
        fetching: PropTypes.bool,
        comments: PropTypes.string,
        attachments: PropTypes.arrayOf(PropTypes.shape({
            attachment: PropTypes.shape({
                name: PropTypes.string
            }),
            comments: PropTypes.string
        })),
        posting: PropTypes.bool,
        badMsg: PropTypes.string,
        msg: PropTypes.string,
        sizeLimitDescription: PropTypes.string,
        tagsDescription: PropTypes.string,
        page: PropTypes.number
    }).isRequired,
    CalculateFeaturedOverview: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    HandleInputChange: PropTypes.func.isRequired,
    OnDrop: PropTypes.func.isRequired,
    changeOverviewAttachment: PropTypes.func.isRequired,
    removeOverviewAttachment: PropTypes.func.isRequired,
    addAnotherOverviewAttachment: PropTypes.func.isRequired,
    CheckUserOverviewTabCheckBox: PropTypes.func.isRequired,
    ApplicationPolicyStore: PropTypes.shape({
        usersOverviewTabCheckBoxes: PropTypes.shape({
            all: PropTypes.bool,
            arag: PropTypes.bool,
            aragAndMedicalExperts: PropTypes.bool
        }).isRequired
    }).isRequired,
    UserRole: PropTypes.string.isRequired,
    PageShift: PropTypes.func.isRequired,
    onDropdownChange: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    overviewTabFilterVisibility: PropTypes.func.isRequired,
    overviewTabFilterVisibilityReset: PropTypes.func.isRequired,
};

export default OverviewTab;